import React from 'react'

const Info = () => {
    return (
        <div className='m-4 p-4 justify-center items-center text-center'>
            <div>This was made during a <a href='https://www.mintbean.io/'>Mintbean</a> Hackathon. </div>
            <div>Check out the code repo <a href='https://github.com/k-charette/mintbean-currency'>here</a> </div>
        </div>
    )
}

export default Info